import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import canUseDOM from "../../../../utils/can-use-dom";
import { ErrorBoundary } from "../../error-boundary";

const CarouselBase = lazy(() => import(/* webpackChunkName: "glide" */ "./glide-carousel-base"));

export const GlideCarousel = props => {
  return canUseDOM ? RenderOnBrowser(props) : RenderDefault(props);
};

const RenderOnBrowser = props => (
  <>
    <ErrorBoundary>
      <Suspense fallback={<RenderDefault {...props} />}>
        <CarouselBase {...props} />
      </Suspense>
    </ErrorBoundary>
  </>
);

const RenderDefault = props => {
  return get(props, ["children", 0], null);
};

GlideCarousel.propTypes = {
  InitRenderTemplate: PropTypes.element
};
